import styled from "styled-components";

export const CardWrapper = styled.div`
  width: 299px;
  height: 330px;
  border-radius: 8px;
  position: relative;
  background: ${({ background }) => (background ? background : "#fff")};
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);

  .ant-carousel .slick-prev {
    left: 10px;
    top: 45%;
    position: absolute;
    z-index: 10000;
    background-color: rgb(58 58 61 / 62%);
    font-size: 20px;
    color: white;
    width: 32px;
    height: 32px;
    padding: 8px;
    border-radius: 50%;
  }
  .ant-carousel .slick-next {
    top: 45%;
    right: 10px;
    position: absolute;
    z-index: 10000;
    background-color: rgb(58 58 61 / 62%);
    font-size: 20px;
    color: white;
    width: 32px;
    height: 32px;
    padding: 8px;
    border-radius: 50%;
  }
  & .card-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 10px 16px;
    font-weight: 500;
    font-size: 15px;
    color: #343c6a;
  }
  .truncate-text {
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Qatordan soni */
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }
  .dotsWrap {
    display: flex;
    justify-content: flex-end;
    /* width: 100%; */
    border: none;
    outline: none;
    background: none;
  }

  & .three-dots {
    cursor: pointer;
    color: #8490a5;
    font-size: 22px;
  }

  & .image-wrapper {
    width: 299px;
    height: 187px;
    overflow: hidden;
    position: relative;

    .picture {
      width: 299px;
      height: 187px;
      object-fit: cover;
    }
  }

  & .card-title {
    width: 80%;
    margin-top: 12px;
    color: #8490a5;
    font-size: 15px;
    line-height: 20.8px;
    font-weight: 400;
    padding-left: 16px;
    word-wrap: break-word;
    cursor: pointer;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Qatordan soni */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & .card-date-and-views {
    gap: 20px;
    padding-left: 16px;
  }

  & .innner-date-and-view {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
    font-size: 14px;
    font-weight: 400;
    line-height: 12px;
    color: #8490a5;
  }
  & .innner-url-and-view {
    display: flex;
    align-items: center;
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 15px;
    color: #005cf6;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Qatordan soni */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & .card-body {
    font-weight: 400;
    font-size: 15px;
    line-height: 15px;
    width: 100%;
    margin-top: 12px;
    padding-left: 16px;
    word-wrap: break-word;
    color: #8490a5;
  }
`;

export const ThreeDotsContainer = styled.div`
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 1;
  width: 100px;
  height: 50px;
  font-size: 13px;
  font-weight: 500;
  background-color: #fff;
  color: #343c6a;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  cursor: pointer;
  box-shadow: 0px 0px 10px #cececf;
`;

export const UpdateIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: var(--sidebar-item-active);
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: red;
  }
`;
